import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import { TempFilesApiObject } from '@qaroni-core/types/files/temp-files.response';

@Injectable({
  providedIn: 'root',
})
export class TempFilesHttpService {
  private http = inject(HttpClient);

  public uploadTempFile$(file: FormData) {
    const url = `${ApiQWorkardsEnv.baseUrl}/files/temps/storages`;
    return this.http.post<TempFilesApiObject>(url, file);
  }
}
